import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './layouts/Layout';
import PrivateRoute from './utils/PrivateRute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Autorizaciones from './pages/Validation';
// import Maintenance from './pages/Maintenance'; // Se desactiva por ahora

function App() {
  return (
    <Router>
      <Routes>
        {/* Página principal accesible sin autenticación */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/registro" element={<Register />} /> */}

          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/solicitud" element={
            <PrivateRoute>
              <Autorizaciones />
            </PrivateRoute>
          } />

          {/* Ruta antigua de home redirige a raíz (opcional) */}
          <Route path="/home" element={<Navigate to="/" />} />
        </Route>

        {/* Maintenance no es accesible ahora */}
        {/* <Route path="/mantenimiento" element={<Maintenance />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
